import React from 'react';
import { Smartphone, Wrench, Users, BarChart3 } from 'lucide-react';
export function OperationalPlaybookSection() {
  const playbook = [{
    icon: Smartphone,
    title: 'Technology Integration',
    items: ['Mobile payment systems and loyalty programs', 'Real-time equipment monitoring and alerts', 'Customer communication and feedback tools', 'Operational dashboards and analytics']
  }, {
    icon: Wrench,
    title: 'Equipment Excellence',
    items: ['Preventive maintenance schedules', 'Energy-efficient equipment upgrades', 'Rapid repair response protocols', 'Equipment lifecycle management']
  }, {
    icon: Users,
    title: 'Customer Experience',
    items: ['Clean, well-lit, safe facilities', 'Consistent pricing and policies', 'Responsive customer service', 'Amenities and convenience features']
  }, {
    icon: BarChart3,
    title: 'Performance Management',
    items: ['Daily operational metrics tracking', 'Revenue optimization strategies', 'Cost control and efficiency gains', 'Continuous improvement processes']
  }];
  return <section className="py-24 bg-[#0f2424]" data-id="element-149">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-150">
        <div className="text-center mb-16" data-id="element-151">
          <h2 className="text-sm font-semibold text-[#4fd1c5] tracking-widest uppercase mb-4" data-id="element-152">
            Our Playbook
          </h2>
          <h3 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-153">
            How We Drive Value
          </h3>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed" data-id="element-154">
            Once we acquire a location, we implement our proven operational
            playbook to enhance performance, improve customer satisfaction, and
            maximize value.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-155">
          {playbook.map((section, index) => {
          const Icon = section.icon;
          return <div key={index} className="bg-[#0b1a1a] border border-gray-800 rounded-xl p-8 hover:border-[#4fd1c5]/30 transition-all duration-300" data-id="element-156">
                <div className="flex items-center gap-4 mb-6" data-id="element-157">
                  <div className="w-12 h-12 rounded-lg bg-[#4fd1c5]/10 flex items-center justify-center" data-id="element-158">
                    <Icon className="h-6 w-6 text-[#4fd1c5]" data-id="element-159" />
                  </div>
                  <h4 className="text-xl font-bold text-white" data-id="element-160">
                    {section.title}
                  </h4>
                </div>
                <ul className="space-y-3" data-id="element-161">
                  {section.items.map((item, itemIndex) => <li key={itemIndex} className="flex items-start gap-3" data-id="element-162">
                      <div className="w-1.5 h-1.5 rounded-full bg-[#4fd1c5] mt-2 flex-shrink-0" data-id="element-163"></div>
                      <span className="text-gray-400" data-id="element-164">{item}</span>
                    </li>)}
                </ul>
              </div>;
        })}
        </div>
      </div>
    </section>;
}